export { default as translations } from './translations.json';

export const MIN_INSTALLMENTS = 2;
export const MAX_INSTALLMENTS = 4;
export const MIN_FIRST_PAYMENT_PCT = 0.25;

/**
 * Get payment plan from transaction.
 * @param {Object|null} transaction
 * @returns {Object|null}
 */
export const getPaymentPlan = (transaction) =>
  transaction?.attributes?.protectedData?.paymentPlan || null;

export const hasPaymentPlan = (transaction) => !!getPaymentPlan(transaction);

/**
 * Get next pending installment.
 * @param {Object|null} transaction
 * @returns {Object|null}
 */
export const getNextInstallment = (transaction) => {
  const plan = getPaymentPlan(transaction);
  if (!plan?.installments) return null;
  return plan.installments.find(i => i.status === 'pending') || null;
};

/**
 * Calculate total paid so far.
 * @param {Object[]} installments
 * @returns {number}
 */
export const getTotalPaid = (installments = []) =>
  installments.filter(i => i.status === 'paid').reduce((s, i) => s + i.amountCents, 0);
